module.exports = __webpack_public_path__ + "img/video.efdc82fe.png";